import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshAdjustmentService } from 'app/core/services/refresh-adjustment/refresh-adjustment.service';

@Component({
  selector: 'dialog-delete-adjustment',
  templateUrl: './dialog-delete-adjustment.component.html',
  styleUrls: ['./dialog-delete-adjustment.component.scss']
})
export class DialogDeleteAdjustmentComponent implements OnInit {

  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteAdjustmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private payrollDefinitionService: PayrollDefinitionService,
    private refreshAdjustmentService: RefreshAdjustmentService
  ) { }

  ngOnInit(): void { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteAdjustment() {
    this.isLoading = true;
    this.payrollDefinitionService.deleteAdjustment(this.data.id).subscribe({
      next: () => {
        this.refreshAdjustmentService.emitRefresh(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error deleting adjustment:', err);
      },
    });
  }
}
